var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider",style:(_vm.fundoSlider)},[_c('land-page-header',{attrs:{"backgroundTransparent":true}}),_c('land-page-search'),_c('div',[(!_vm.parceiro || _vm.parceiro === 'acerte_aqui')?_c('land-page-totals'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }